import { Component, OnInit } from '@angular/core';
import { SlimLoadingBarService } from 'ng2-slim-loading-bar';
import { LeadsService } from '../services/lead-service/lead-service.service';
import { ErrorHandlerService } from '../services/shared/error-handler.service';

@Component({
  selector: 'app-duplicated-leads',
  templateUrl: './duplicated-leads.component.html',
  styleUrls: ['./duplicated-leads.component.css']
})
export class DuplicatedLeadsComponent implements OnInit {

  dublicated_raw_data: any = [];
  dublicated_leads: any;
  last_page_url: any;

  current_page: any;
  per_page: any;
  total: any;
  totalRec: any;
  pageTest: any = 1;
  lg = 'lg';

  constructor(
    private leadsService: LeadsService, 
    private slimLoadingBarService: SlimLoadingBarService,
    private errorHandlerService: ErrorHandlerService
    ) { }

  ngOnInit() {
    this.getDuplicatedLeads();
  }

  getDuplicatedLeads() {
    this.slimLoadingBarService.start();
    this.leadsService.getDuplicatedLeads()
      .subscribe((res: any) => {
        this.slimLoadingBarService.complete();
        this.dublicated_raw_data = res;
        this.dublicated_leads = res.data;
        this.last_page_url = res.last_page_url;
        this.current_page = 1;
        this.per_page = res.to;
        this.total = res.total;
        this.totalRec = res.total;
      }, err => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      });
  }
  
  pageChange(event) {
    let arr = this.last_page_url.split('?');
    let selectedUrl = `${arr[0]}?page=${event}`;
    this.infinite(selectedUrl, event);
  }

  infinite(url, number) {
    this.slimLoadingBarService.start();
    this.leadsService.infinit(url).subscribe(
      (data: any) => {
        this.dublicated_raw_data = data;
        this.dublicated_leads = data.data;
        this.totalRec = data.total;
        this.current_page = number;
        this.per_page = data.to;
        this.total = data.total;
        this.slimLoadingBarService.complete();
      },
      err => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/duplicated-leads/duplicated-leads.component.ts